module.exports = __webpack_public_path__ + "static/img/mikse.bfcc3ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mikse.png
// module id = YIip
// module chunks = 0